import { connectHook } from 'app/common/components/connect-hook';
import { EnumWidget } from './enum-widget.js';
import { useEnumWidget } from './enum-widget-hook.js';

export default connectHook(EnumWidget, useEnumWidget);
